<div class="page-wrapper">
  <deloitteai-header [logoUrl]="logoUrl" *ngIf="!environment['hideHeader']"> </deloitteai-header>

  <aihub-loader></aihub-loader>
  <router-outlet></router-outlet>

  <deloitteai-footer *ngIf="!environment['hideFooter']"></deloitteai-footer>
</div>
<!-- <router-outlet></router-outlet> -->
